import React from 'react';
import lightGreen from '@material-ui/core/colors/lightGreen'
import orange from '@material-ui/core/colors/orange'

import { currencyMaker, priceMaker } from 'services/helpers'

const tableCellStyles = {
  border: '1px solid #b9b9b9',
  padding: '1px'
};

const tableRowStyle = {
  highlightConfirmed: {
    backgroundColor: lightGreen['A100'],
  },
  highlightNoResponse: {
    backgroundColor: orange['A100'],
  },
};

export const BookingSheetRow = ({
  from, to, surname, name, phone, price, source, sourceId, i,
  note, fromCityTypeByLabel, paidStatus, confirmed, status, place,
}) => {
  const currency = currencyMaker(fromCityTypeByLabel, null, sourceId);
  const displayPrice = priceMaker(price, paidStatus);

  return (
    <tr style={status === 'confirmed' || confirmed
      ? tableRowStyle.highlightConfirmed
      : status === 'noResponse'
        ? tableRowStyle.highlightNoResponse
        : null}
    >
      <td style={tableCellStyles}>{i}</td>
      <td style={tableCellStyles}>{from}</td>
      <td style={tableCellStyles}>{to}</td>
      <td style={tableCellStyles}>{surname}</td>
      <td style={tableCellStyles}>{name}</td>
      <td style={tableCellStyles}>{phone}</td>
      <td style={tableCellStyles}>
        {source === 'system'
          ? (
            <del>
              {displayPrice}
            </del>
          )
          : displayPrice}
        {" " + currency}
      </td>
      <td style={tableCellStyles}>{note}</td>
      <td style={tableCellStyles}>{place}</td>
    </tr>
  )
}


// WEBPACK FOOTER //
// ./src/components/BookingsSheet/components/BookingSheetRow/BookingSheetRow.js